import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ChangePasswordData, ChangePasswordErrorResponse, ChangePasswordState, ChangePasswordSuccessResponse } from "./index.types";

const initialState: ChangePasswordState = {
  changePasswordMessage: "",
  changePasswordSuccess: null,
  isChangePasswordLoading: false,
};

const name = "changePassword";

export const changePasswordSlice = createSlice({
  name,
  initialState,
  reducers: {
    changeUserPassword: (state) => {
      state.isChangePasswordLoading = true;
    },
    changeUserPasswordSuccess: (state, action: PayloadAction<ChangePasswordSuccessResponse>) => {
      state.changePasswordSuccess = true;
      state.isChangePasswordLoading = false;
      state.changePasswordMessage = action.payload?.detail || "";
    },
    changeUserPasswordFail: (state, action: PayloadAction<ChangePasswordErrorResponse>) => {
      state.changePasswordSuccess = false;
      state.isChangePasswordLoading = false;
      state.changePasswordMessage = action.payload?.message?.detail || "";
    },
    clearChangePassword: (state) => {
      state.changePasswordMessage = "";
      state.changePasswordSuccess = null;
      state.isChangePasswordLoading = false;
    },
  },
});

export const { changeUserPassword, clearChangePassword } = changePasswordSlice.actions;

export default changePasswordSlice.reducer;

export const changePasswordUser = (data: ChangePasswordData) => ({
  payload: {
    apiName: name,
    data,
    method: "post",
    url: `/api/users/update_password/`,
  },
  type: "changeUserPassword",
});
